const defaults = {
  currentTheme: {
    __typename: 'CurrentTheme',
    theme: 'default',
  },
  currentLanguage: {
    __typename: 'CurrentLanguage',
    language: 'en',
  },
};

export default defaults;
